import React, { useEffect, useState, FC } from "react";
import { useWatch } from "react-hook-form";
import { EmployerPermissions } from "generated/graphql";
import { Option, NullableOption } from "Shared/types/Option";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";

type Props = {
  onChange: (selected: Option[]) => void;
  onBlur?: (evt: React.FocusEventHandler) => void;
  options: Option[];
  placeholder: string;
};

const MultiSelectWrapper: FC<Props> = ({
  onChange,
  onBlur,
  options,
  placeholder,
}) => {
  const [value, setValue] = useState<NullableOption[]>([]);
  const { permissions } = useWatch({});
  const isFullPermissionSelected =
    permissions?.value === EmployerPermissions.FullPermissions;

  const allOption = {
    label: "Select all",
    value: null,
  };

  const onChangeHandler = (selected: NullableOption[]) => {
    if (selected[selected.length-1]?.value === allOption.value) {
      // Consider generalizing this to "All options selected" or passing in a label
      setValue([{ label: "All Pay Groups selected", value: null }]);
      onChange([]);
    } else {
      const realOptions = selected.filter(option => option.value !== null) as Option[];
      setValue(realOptions);
      onChange(realOptions);
    }
  };

  useEffect(() => {
    if (isFullPermissionSelected) {
      onChangeHandler([allOption]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFullPermissionSelected]);

  return (
    <DPReactSelect
      onBlur={onBlur}
      value={value}
      isDisabled={isFullPermissionSelected}
      isMulti
      placeholder={placeholder}
      options={[allOption, ...options]}
      onChange={onChangeHandler}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      maxMenuHeight={120}
    />
  );
};

export default MultiSelectWrapper;
